import { type ModalComponentProps } from '@atlassian/entry-points/modal-context-provider';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { FakeBackgroundProp } from '@atlassian/cross-flow-next-ui/types';
import type { TargetType } from '@atlassiansox/cross-flow-base-types/targets';
import { type EntryPoint, type EntryPointComponent } from 'react-relay';

export const crossFlowModalEntryPoint: EntryPoint<
	EntryPointComponent<
		Record<string, never>,
		Record<string, never>,
		{
			sourceComponent: string;
			sourceContext: string;
			targetProduct: TargetType;
			fakeBackground?: FakeBackgroundProp;
			height?: number | string;
			width?: number | string;
			onActivationSuccess?: () => void;
			onActivationStart?: () => void;
			onActivationFailed?: () => void;
			shouldRedirectOnSuccess?: boolean;
			contextParams?: Record<string, unknown>;
		} & ModalComponentProps,
		Record<string, never>
	>,
	// eslint-disable-next-line @typescript-eslint/ban-types
	{}
> = createEntryPoint({
	root: JSResourceForInteraction(() => import('./cross-flow-modal'), {
		moduleId: 'post-office-cross-flow-modal',
	}),
	getPreloadProps: () => ({}),
});
